import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PencilaltIcon from 'icons/Pencilalt.icon';
import ListingPrices from 'components/ListingPrices';
import { Listing } from 'models/Listing';
import ResolveImage from 'components/ResolveImage';
import { BUTTON_CLASSES } from '../MarketYourDeal/MarketYourDeal.component';
import { ConditionalLink } from 'components/ConditionalLink';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import { getCreateListingRoute } from 'utils';

import './DraftListingCard.styles.scss';

type DraftListingCardProps = {
  className?: string;
  listing?: Partial<Listing>;
  areActionsDisabled?: boolean;
};

const DraftListingCard: React.FC<DraftListingCardProps> = (props) => {
  const { className, listing, areActionsDisabled } = props;

  const {
    askingPriceSelect,
    averageStockValue,
    amount,
    amountFrom,
    amountTo,
    revenue,
    EBITDA,
    stockAtValue,
    currency,
    listingTitle,
    locationState,
    dealLocation,
    industry,
    gallery,
    type,
    dealRoomId,
    _id: listingId,
    amountRequiredVisibleInfo,
    amountFromRequiredVisibleInfo,
    amountToRequiredVisibleInfo,
    revenueRequiredVisibleInfo,
    EBITDARequiredVisibleInfo,
    averageStockValueRequiredVisibleInfo,
  } = listing || {};

  const { t } = useTranslation();

  const classes = classNames('draft-listing-card', 'white-panel', className);

  return (
    <div className={classes}>
      <p>{t('marketYourDealToBuyers')}</p>

      <span className="badge">{t('draftListing')}</span>

      <div className="listing-info">
        <div>
          <p className="title">{listingTitle || t('noTitle')}</p>
          <p className="location">
            {locationState || dealLocation}
            {industry && <span>{industry}</span>}
          </p>
        </div>

        <ResolveImage src={getImgUrl(gallery?.[0]?.url, RESIZED_WIDTH[240])} />
      </div>

      <ListingPrices
        askingPrice={askingPriceSelect}
        amount={amount}
        amountFrom={amountFrom}
        amountTo={amountTo}
        revenue={revenue}
        EBITDA={EBITDA}
        averageStockValue={averageStockValue}
        stockAtValue={stockAtValue}
        currency={currency}
        amountRequiredVisibleInfo={amountRequiredVisibleInfo}
        amountFromRequiredVisibleInfo={amountFromRequiredVisibleInfo}
        amountToRequiredVisibleInfo={amountToRequiredVisibleInfo}
        revenueRequiredVisibleInfo={revenueRequiredVisibleInfo}
        EBITDARequiredVisibleInfo={EBITDARequiredVisibleInfo}
        averageStockValueRequiredVisibleInfo={
          averageStockValueRequiredVisibleInfo
        }
      />

      <ConditionalLink
        isDisabled={areActionsDisabled}
        disabledClassName={BUTTON_CLASSES}
        linkClassName={BUTTON_CLASSES}
        to={getCreateListingRoute(dealRoomId, listingId, type)}
      >
        <PencilaltIcon />
        {t('completeListing')}
      </ConditionalLink>
    </div>
  );
};

export default DraftListingCard;
